import { useMutation, mutationOptions } from "@tanstack/react-query";
import { cropImage, removeBackgroundFn } from "@app/services/photoshop";
import { retry } from "@app/store/query";

export const photoshopKey = {
  all: ["photoshop"],
  cropImages: () => [...photoshopKey.all, "cropImage"],
  cropImage: (variables) => [...photoshopKey.cropImages(), variables],
  removeBackgrounds: () => [...photoshopKey.all, "removeBackground"],
  removeBackground: (variables) => [
    ...photoshopKey.removeBackgrounds(),
    variables,
  ],
};

export const cropImageMutationOptions = (options = {}) =>
  mutationOptions({
    ...options,
    retry: retry(1),
    mutationFn: (variables, { signal }) => cropImage(variables, { signal }),
    onSuccess: (data, variables, onMutateResult, context) => {
      const { client } = context;
      client.setQueryData(photoshopKey.cropImage(variables), data);
      options.onSuccess?.(data, variables, onMutateResult, context);
    },
  });

export const useCropImage = (options = {}) => {
  return useMutation(cropImageMutationOptions(options));
};

export const removeBackgroundMutationOptions = (options = {}) =>
  mutationOptions({
    ...options,
    mutationFn: ({ statusCallback, ...variables }, { signal }) =>
      removeBackgroundFn(variables, signal, statusCallback),
    onSuccess: (data, variables, onMutateResult, context) => {
      const { client } = context;
      client.setQueryData(photoshopKey.removeBackground(variables), data);
      options.onSuccess?.(data, variables, onMutateResult, context);
    },
  });

export const useRemoveBackground = (options = {}) => {
  return useMutation(removeBackgroundMutationOptions(options));
};
